<script lang="ts">
  import { BusinessReviewEntryType } from 'src/function-utils/data-models';
  import { formatReviewCardDate } from 'src/utils/date';
  import VideoReviewPlayer from './video-review-player.svelte';

  export let type:
    | BusinessReviewEntryType.RAVELY_VIDEO
    | BusinessReviewEntryType.YOUTUBE_VIDEO;
  export let user: {
    name: string;
    pictureUrl?: string;
    avatarUrl?: string;
    title?: string;
    socialLink?: string;
  };
  export let reviewOriginUrl: string = '';
  export let date: number | string | void;

  let videoType: 'video' | 'youtube';
  let src;
  let posterUrl;

  $: {
    if (type === BusinessReviewEntryType.RAVELY_VIDEO) {
      const [_src, _posterUrl] = reviewOriginUrl.split(',');
      videoType = 'video';
      src = _src;
      posterUrl = _posterUrl;
    } else if (type === BusinessReviewEntryType.YOUTUBE_VIDEO) {
      videoType = 'youtube';
      src = reviewOriginUrl;
      posterUrl = '';
    }
  }

  $: formattedDate = date && formatReviewCardDate(date);
</script>

{#if src}
  <div class="videoReviewCardPlayerContainer">
    <VideoReviewPlayer
      class="videoReviewPlayer"
      {videoType}
      {src}
      {posterUrl}
    />

    <div class="videoReviewCardUserContainer">
      <a
        class="videoReviewCardSocialLink"
        href={user.socialLink || undefined}
        target="_blank"
      >
        <div class="videoReviewCardUserName text-ellipsis">{user.name}</div>

        {#if user.title}
          <div class="videoReviewCardUserTitle text-ellipsis">
            {user.title}
          </div>
        {/if}
      </a>

      {#if formattedDate}
        <div class="mt-xs text-caption">{formattedDate}</div>
      {/if}
    </div>
  </div>
{/if}

<style lang="scss">
  $zIndex: 51; // Let it go above the poster and control
  $playBtnWidth: 50px;

  .videoReviewCardPlayerContainer {
    position: relative;
    min-height: 100%;
    background-color: black;
    display: flex;
    align-items: center;

    :global(.videoReviewPlayer) {
      width: 100%;
    }
  }

  .videoReviewCardUserContainer {
    position: absolute;
    bottom: 0px;
    right: 0px;
    text-align: right;
    color: white;
    text-shadow: 0 0 4px black;
    z-index: $zIndex;
    margin: 8px 8px 4px 0px;
    max-width: calc(100% - #{$playBtnWidth});

    .videoReviewCardSocialLink {
      color: inherit;
      display: inline-block;
      max-width: 100%;

      &:hover {
        text-decoration: underline;
      }
    }

    .videoReviewCardUserName {
      font-size: 1.25rem;
      font-weight: 600;
    }

    .videoReviewCardUserTitle {
      font-weight: 600;
    }
  }
</style>
